import { Row } from "react-bootstrap";
import {
  SiVisualstudiocode, SiGithub, SiGitlab, SiGnubash,
  SiUbuntu, SiPostman, SiWindows, SiOpenai,
} from "react-icons/si";

const tools = [
  { icon: <SiUbuntu />,          label: "Ubuntu" },
  { icon: <SiWindows />,         label: "Windows Server" },
  { icon: <SiVisualstudiocode />,label: "VS Code" },
  { icon: <SiGithub />,          label: "GitHub" },
  { icon: <SiGitlab />,          label: "GitLab" },
  { icon: <SiGnubash />,         label: "Bash" },
  { icon: <SiPostman />,         label: "Postman" },
  { icon: <SiOpenai />,          label: "ChatGPT" },
];

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px", flexWrap: "wrap" }}>
      {tools.map((item) => (
        <div key={item.label} className="tech-icons">
          {item.icon}
          <span className="tech-icon-label">{item.label}</span>
        </div>
      ))}
    </Row>
  );
}

export default Toolstack;
